const modules = import.meta.globEager([
  '~/partials/erb_wrappers/ErbDemoDayBanner.jsx',
])

export default modules
